/*
*   @site           Preloaded: Site
*   @function       Module: Media Parallax (Case Study Header, Inline Image and Video)
*   @author         Last17
*   @copyright      Copyright 2025, Preloaded.com
*   @version        0.01
*
*********************************************************************************************/


//-----------------------------------------------
// Imports
//-----------------------------------------------

//Template and controller
import ModuleTemplate from '../_templates/ModuleTemplate';
import LayoutController from '../_controllers/LayoutController';

//Libs
import Player from '@vimeo/player';

//-----------------------------------------------
// Class Definition
//-----------------------------------------------
export default class ModuleImageParallax extends ModuleTemplate {

  //-----------------------------------------------
  // Init
  //-----------------------------------------------
  init() {
    //Calculate a type
    this.type = this.element.querySelector('.image__obj') ? 'image' : 'video';

    //Act on type
    (this.type === 'image') ? this.initImage() : this.initVideo();
  }


  //-----------------------------------------------
  // Init Image
  //-----------------------------------------------
  initImage() {
    this.image = this.element.querySelector('.image__obj');
    this.initScroll();
  }


  //-----------------------------------------------
  // Init Video
  //-----------------------------------------------
  initVideo() {
    //Elements
    this.iframe = this.element.querySelector('iframe');
    this.videoWrapper = this.element.querySelector('.video-wrapper');

    //Scrolling for videos
    this.initScroll();

    //Init if found
    if(this.iframe) {
      //Create a player
      this.player = new Player(this.iframe);

      //On pause
      this.player.on('pause', function(data) {
        this.videoPause();
      }.bind(this));

      //On play
      this.player.on('play', function(data) {
        this.videoPlay();
      }.bind(this));
    }
  }


  //-----------------------------------------------
  // Init Scroll
  //-----------------------------------------------
  initScroll() {
    //Scroll values
    this.offsetX = {
      'desktop': this.element.getAttribute('data-offset-x-desktop') || '50%',
      'mobile': this.element.getAttribute('data-offset-x-mobile') || '50%',
    };

    //Scroll rates ()
    this.scrollRate = {
      'desktop': this.element.getAttribute('data-scroll-rate-desktop') || 0.35,
      'mobile': this.element.getAttribute('data-scroll-rate-mobile') || 0.35,
    };

    //Scroll events
    this.subscribeToEvent('scroll');
  }

  //-----------------------------------------------
  // Set layout
  //-----------------------------------------------
  setLayout(layout) {
    //Parent
    super.setLayout(layout);

    //Position
    if(this.flags.listen.scroll) {
      this.setScrollPosition();
    }
  }

  //-----------------------------------------------
  // Set position
  //-----------------------------------------------
  setScrollPosition() {
    //Vars
    let viewportOffset = this.element.getBoundingClientRect();
    let prop = 0;
    let backgroundOffset = {
      x: this.offsetX[LayoutController.layout],
      y: '0%'
    };

    //Calculate scroll start and end points for the module
    let scrollBounds = this.getScrollBounds();

    //If we are within the scroll bounds
    if(window.scrollY >= scrollBounds.min && window.scrollY <= scrollBounds.max) {
      //Proportion of scroll
      prop = (window.scrollY - scrollBounds.min) / (scrollBounds.max - scrollBounds.min);
      prop = Math.min(1, Math.max(0, prop)); //clamped

      //Act on type
      if(this.type === 'image') {
        //-----------------------------------------------
        // Image Scroll
        //-----------------------------------------------
        if(this.element.offsetTop > 0) {
          //Element is part way down the page so instead of using translate we use the natural overage within the image
          let percentage = ((1 - prop) * 75); //(100 -> 0)
          backgroundOffset.y =  percentage + '%';
        } else {
          //Element is at the top of the page, so we can use translate
          let offset = (window.scrollY - scrollBounds.min) * this.scrollRate[LayoutController.layout];
          this.image.style['transform'] = 'translateY(' + offset +'px)';
        }
        
        ////Style
        this.image.style['background-position'] = backgroundOffset.x + ' ' + backgroundOffset.y;
        this.image.style['object-position'] = backgroundOffset.x + ' ' + backgroundOffset.y;
      } else {
        //-----------------------------------------------
        // Video scroll
        //-----------------------------------------------
        if(this.element.offsetTop > 0) {
          //Element is part way down the page so instead of using translate we use the natural overage within the video (this one doesn't work as we would have to overflow the image)
        } else {
          //Element is at the top of the page, so we can use
          this.iframe.style['transform'] = 'translateY(' + ((window.scrollY - scrollBounds.min) * this.scrollRate[LayoutController.layout]) +'px)';
        }
      }
    }
  }


  //-----------------------------------------------
  // Scroll event
  //-----------------------------------------------
  scrollEvent(data) {
    //Parent
    super.scrollEvent(data);
    
    //This
    this.setScrollPosition();
  }


  //-----------------------------------------------
  // Video Play
  //-----------------------------------------------
  videoPlay() {
    //Add the playing class
    this.videoWrapper.classList.add('playing');
  }

  
  //-----------------------------------------------
  // Video Pause
  //-----------------------------------------------
  videoPause() {
  }

}